import React, {useCallback, useEffect, useMemo, useState} from 'react';

import type {AfriexRoles} from '@/types';

import type {AuthSessionUser} from './useAuth';
import {AuthContext} from './useAuth';

export const AuthProvider = ({children}: {children: React.ReactNode}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState<AfriexRoles>();
  const [adminUser, setAdminUser] = useState<AuthSessionUser | undefined>();
  const [authLoading, setAuthLoading] = useState<boolean>(true);

  const login = useCallback((irole: AfriexRoles, admin: AuthSessionUser) => {
    setIsAuthenticated(true);
    setRole(irole);
    setAdminUser(admin);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('admin-email');
    localStorage.removeItem('admin-firstname');
    localStorage.removeItem('admin-role');
    localStorage.removeItem('afriex-token');
    localStorage.removeItem('device-token');
    localStorage.removeItem('nonce');
    localStorage.removeItem('user-id');
    setIsAuthenticated(false);
    setRole(undefined); // Clear role on logout
    setAdminUser(undefined); // Clear adminUser on logout
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('afriex-token');
    const role = localStorage.getItem('admin-role');
    const email = localStorage.getItem('admin-email');
    const firstName = localStorage.getItem('admin-firstname');

    if (token && token?.length > 5) {
      login(role as AfriexRoles, {email, firstName});
    }
  }, [login]);

  const memoedValue = useMemo(
    () => ({
      isAuthenticated,
      login,
      role,
      logout,
      adminUser,
      authLoading,
    }),
    [isAuthenticated, login, role, logout, adminUser, authLoading],
  );

  useEffect(() => {
    const token = localStorage.getItem('afriex-token');
    if (token && token?.length > 5) {
      setIsAuthenticated(true);
    }
    setAuthLoading(false);
  }, []);

  return (
    <AuthContext.Provider value={memoedValue}>{children}</AuthContext.Provider>
  );
};
